export default __webpack_public_path__ + "static/media/iconCenterGPSWhite.1b64ec09.svg";